import { render, staticRenderFns } from "./TheRecipientsAreaSelectManually.vue?vue&type=template&id=287cb2d3&scoped=true"
import script from "./TheRecipientsAreaSelectManually.vue?vue&type=script&lang=js"
export * from "./TheRecipientsAreaSelectManually.vue?vue&type=script&lang=js"
import style0 from "./TheRecipientsAreaSelectManually.vue?vue&type=style&index=0&id=287cb2d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287cb2d3",
  null
  
)

export default component.exports